import { createFileRoute, redirect } from "@tanstack/react-router";

/** A product is edited in a dialog on the shelf; this address still opens it there. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/offer/products/$productId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/offer/products", search: { product: params.productId }, replace: true });
  },
});
